import React from 'react';
import { motion } from 'framer-motion';
import { GavelIcon, UsersIcon, ShieldCheckIcon, ScaleIcon, HandshakeIcon, LandmarkIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';
import { boardExperience, accents } from '../../data/site';
const icons = [GavelIcon, UsersIcon, ShieldCheckIcon, ScaleIcon, HandshakeIcon, LandmarkIcon];
export function BoardExperience() {
  return <section id="board" className="relative scroll-mt-24 overflow-hidden bg-mist py-24 lg:py-32" data-id="element-78" data-mp="2tekdc1a36w2h">
      <div className="pattern-lattice absolute inset-0 opacity-50" aria-hidden="true" data-id="element-79" data-mp="2ocv5eui5uyim" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10" data-id="element-80" data-mp="2kd4duokt8ed1">
        <SectionHeading eyebrow="Investor & Board Experience" title="Counsel that directors and investors rely on." data-id="element-81" data-mp="2fe9p7605vvl0" />

        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-82" data-mp="ij55oc2zid4k">
          {boardExperience.map((card, index) => {
          const Icon = icons[index % icons.length];
          const accent = accents[index % accents.length];
          return <Reveal key={card.title} delay={index % 3 * 0.07} data-id="element-83" data-mp="1lq95scjl9jsm" data-mpi={index}>
                <motion.article whileHover={{
              y: -8
            }} transition={{
              duration: 0.4,
              ease: [0.22, 1, 0.36, 1]
            }} className="glass-light group relative h-full overflow-hidden rounded-xl p-8 shadow-[0_20px_50px_-40px_rgba(7,26,47,0.5)]" data-id="element-84" data-mp="17poppo52622t">
                  <span className="absolute inset-x-0 top-0 h-1 origin-left scale-x-0 transition-transform duration-500 group-hover:scale-x-100" style={{
                backgroundColor: accent
              }} aria-hidden="true" data-id="element-85" data-mp="24g7fex31bkyd" />
                  <span className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full opacity-0 blur-2xl transition-opacity duration-500 group-hover:opacity-60" style={{
                backgroundColor: `${accent}66`
              }} aria-hidden="true" data-id="element-86" data-mp="2jcygdascx4q3" />
                  <span className="relative inline-flex h-12 w-12 items-center justify-center rounded-lg text-white transition-transform duration-500 group-hover:scale-110" style={{
                backgroundColor: accent
              }} data-id="element-87" data-mp="2t013f5elu5oq">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-88" data-mp="2j4qvy25ft63k" />
                  </span>
                  <h3 className="relative mt-6 font-display text-xl font-normal text-navy" data-id="element-89" data-mp="2f2vvezvbywqu">{card.title}</h3>
                  <p className="relative mt-3 text-sm leading-relaxed text-charcoal/70" data-id="element-90" data-mp="2a88atc3g6mhj">{card.description}</p>
                </motion.article>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}